module.exports = __webpack_public_path__ + "media/images/flags/4x3/mwi-8e62aef0f99d9ec2a97ddfaac192bed9.svg";